
import { FormGroup, FormControl, FormArray, Validators } from '@angular/forms';
import { WorkSendMessagePersonalDto } from '../models/work-send-message-personal-dto';
import { WorkSendMessageAttachmentDto } from '../models/work-send-message-attachment-dto';

export function getSendMessageDtoFormGroup() {
return new FormGroup({
    messageSubject: new FormControl<string | undefined>('', [Validators.required]),
    messageText: new FormControl<string | undefined>('', [Validators.required]),
    recipients: new FormControl<WorkSendMessagePersonalDto[]>([]),
    attachments: new FormControl<WorkSendMessageAttachmentDto[]>([]),
})
;
}
      